/* External */
import { useState, useCallback, useEffect } from 'react';

/* Utils */
import { Direction } from '../utils/spatialNavigation';

export default function useGetPositionCarousel({
  carouselLength, onNoMoreLeftElements, initialPosition = 0, onPositionCarouselChange,
}) {
  const [positionCarousel, setPositionCarousel] = useState(initialPosition);

  const handleArrowPress = useCallback((direction) => {
    if (direction === Direction.RIGHT) {
      setPositionCarousel((currentPosition) => {
        if (currentPosition < carouselLength - 1) {
          return currentPosition + 1;
        }
        return currentPosition;
      });
    } else if (direction === Direction.LEFT) {
      setPositionCarousel((currentPosition) => {
        if (currentPosition > 0) {
          return currentPosition - 1;
        }
        if (onNoMoreLeftElements) {
          setTimeout(() => {
            onNoMoreLeftElements();
          }, 0);
        }
        return currentPosition;
      });
    }
  }, [carouselLength, onNoMoreLeftElements]);

  useEffect(() => {
    if (onPositionCarouselChange) {
      onPositionCarouselChange(positionCarousel);
    }
  }, [onPositionCarouselChange, positionCarousel]);

  return [positionCarousel, handleArrowPress, setPositionCarousel];
}
